{
  "shellSkipMenuMainContent": "跳至主要內容"
}
